/* istanbul ignore file */
import { put, takeLatest } from 'redux-saga/effects'
import { buildApiSaga } from 'commons/js/sagas/helpers'
import * as api from 'commons/js/api'
import Routes from 'commons/js/routes/routes'
import {
    UNPROCESSABLE_ENTITY_ERROR,
    REQUEST_RENTAL_CAR_CONTRACT,
    RECEIVE_RENTAL_CAR_CONTRACT,
    CONTRACT_RENTAL_CAR,
} from '../actions/types'
import { receiveRentalCarContract, confirmRentalCarContract } from '../actions/rentalCarContract'
import { navigateTo } from '../actions/navigation'

function mapError (result) {
    if (result.error.name === UNPROCESSABLE_ENTITY_ERROR) {
        return {
            ...result,
            omitGlobalError: true,
        }
    }

    return result
}

export const fetchRentalCarContract = buildApiSaga({
    request: api.getRentalCarContract,
    action: receiveRentalCarContract,
    mapError,
})

export const createRentalCarContract = buildApiSaga({
    request: api.createRentalCarContract,
    action: confirmRentalCarContract,
    mapError,
})

export function * watchNavigate ({ rentalCarContract, navigate }) {
    if (rentalCarContract && rentalCarContract.id && navigate) {
        yield put(navigateTo({
            url: Routes.rentalCarContractNewPath({
                id: rentalCarContract.id,
            }),
        }))
    }
}

export function * watchReceiveRentalCarContract () {
    yield takeLatest(RECEIVE_RENTAL_CAR_CONTRACT, watchNavigate)
}

export function * watchRentalCarContract () {
    yield takeLatest(REQUEST_RENTAL_CAR_CONTRACT, fetchRentalCarContract)
}

export function * watchContractRentalCar () {
    yield takeLatest(CONTRACT_RENTAL_CAR, createRentalCarContract)
}

export default watchRentalCarContract
